<template>
  <div>
    <div class="air__utils__heading">
      <h5>Dashboard</h5>
    </div>
    <!-- {{ $t('welcome') }} -->

    <div class="row">
      <div class="col-md-12 d-none d-md-block mb-4">
<!--        <quick-links /> Todo: Temporary commented for role base access feature-->
      </div>
    </div>

    <div class="row" v-if="!loading && data">
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <NeoCountCard
              title="Classes"
              description="Total number of classes"
              :count="data.class_count"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <NeoCountCard
              title="Sessions"
              description="Total number of sessions"
              :count="data.session_count"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <NeoCountCard
              title="Teachers"
              description="Total number of teachers"
              :count="data.total_teacher"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-body neo-dash-card-height-190">
            <p class="card-title font-weight-bold">Enrollments</p>
            <NeoEnrollmentWidget
              :students="data.total_students"
              :enrolled="data.total_enroll"
              :notEnrolled="data.total_non_enroll"
              :activeCount="data.total_active_count"
              :inactiveCount="data.total_inactive_count"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-body neo-dash-card-height-190">
            <p class="card-title font-weight-bold">Working Days</p>
            <NeoWorkingDayWidget
              :running="data.current_working_days"
              :expected="data.expected_working_days"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-body neo-dash-card-height-190">
            <p class="card-title font-weight-bold">Current Session</p>
            <NeoCurrentSessionWidget
              :session="data.current_session"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import QuickLinks from '@/components/dashboard/Quicklinks/index'
import NeoCountCard from '@/components/dashboard/CountCard/index'
import NeoEnrollmentWidget from '@/components/dashboard/Enrollment/index'
import NeoWorkingDayWidget from '@/components/dashboard/Workingday/index'
import NeoCurrentSessionWidget from '@/components/dashboard/CurrentSession/index'

export default {
  components: {
    // QuickLinks,
    NeoCountCard,
    NeoEnrollmentWidget,
    NeoWorkingDayWidget,
    NeoCurrentSessionWidget,
  },
  mounted() {
    this.loading = true
    this.$http.get('/api/reports/dashboard')
      .then(({ data }) => {
        this.data = data.data
        this.loading = false
      })
      .catch(error => {
        console.log(error)
        this.loading = false
      })
  },
  data() {
    return {
      loading: false,
      data: null,
    }
  },
}
</script>
